<template>
  <div>
    <InputLabel
      :name="name"
      :label="label"
      v-if="label"
      for-non-native-element
      :sr-only="srOnly"
      :tooltip="tooltip"
      :tooltip-icon="tooltipIcon"
      :required="required"
    >
      <slot name="label"></slot>
    </InputLabel>
    <div class="flex items-center">
      <Dropdown
        :aria-labelledby="name"
        :aria-describedby="`${name}-help`"
        class="w-full"
        :class="{ 'p-invalid': errorMessage }"
        v-model="value"
        :options="options"
        v-bind="$attrs"
      >
        <template
          v-for="(_, slotName) in $slots"
          :key="slotName"
          #[slotName]="slotData"
        >
          <slot
            v-if="!['label', 'input'].includes(slotName)"
            :name="slotName"
            v-bind="slotData || {}"
          />
        </template>
      </Dropdown>
      <slot name="input"></slot>
    </div>
    <InputError :name="name" :error-message="errorMessage" />
  </div>
</template>

<script>
import { useField } from 'vee-validate';
import { toRef } from 'vue';

import InputLabel from '@/components/forms/helpers/InputLabel.vue';
import InputError from '@/components/forms/helpers/InputError.vue';
import Dropdown from 'primevue/dropdown';

export default {
  name: 'DropdownGroup',
  components: {
    InputLabel,
    InputError,
    Dropdown,
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    options: {
      type: null,
      default: () => [],
    },
    srOnly: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipIcon: {
      type: String,
      default: 'pi-info-circle',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { errorMessage, value } = useField(toRef(props, 'name'));

    return {
      errorMessage,
      value,
    };
  },
};
</script>
